<template>
  <c-modal-form
    :id="$getConst('FORM_ACCESS_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    :error="error"
    title="Запрос на получение доступов"
    @submit="submit()"
  >
    <form>
      <c-select
        v-model="domain"
        :options="domainOptions"
        form-group
        first-option-disabled
      />
      <p class="text-danger">
        Укажите, пожалуйста, какие доступы Вам необходимы:
      </p>
      <div
        v-for="type of formsTypesAccess"
        :key="type"
        class="form-group"
      >
        <input
          v-model="typesAccess"
          type="checkbox"
          :value="type"
        > {{ capitalizeFirstLetter(type) }}
      </div>
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import helper from '../../../../../../../resources/js/mixins/helper'
import apiService from '../../apiService'
import { mapActions, mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно "Запрос на получение доступов".
 */
export default {
  name: 'Access',
  components: {
    CModalForm,
    CSelect,
    DemoDenied
  },
  mixins: [form, helper, modal],
  data: () => {
    return {
      domain: '',
      typesAccess: []
    }
  },
  computed: {
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.sending || this.clientDomainsFetching || this.formsTypesAccessFetching)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domain && this.typesAccess.length && !this.isDemo)
    },
    /**
     * Пункты для выпадающего списка доменов.
     *
     * @returns {*[]}
     */
    domainOptions () {
      return ['Выберите сайт', ...this.clientDomains]
    },
    ...mapState({
      formsTypesAccess: state => state.seo.forms.typesAccess.types,
      formsTypesAccessFetching: state => state.seo.forms.typesAccess.fetching,
      clientDomainsFetching: state => state.seo.client.domains.fetching,
      clientDomains: state => state.seo.client.domains.domains
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  mounted () {
    this.fetchTypesAccess()

    $(`#${this.$getConst('FORM_ACCESS_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.domain = ''
      this.typesAccess = []
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postFormsAccess(this.domain, this.typesAccess)
        .then(() => {
          this.hideModal(this.$getConst('FORM_ACCESS_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    },
    ...mapActions({
      fetchTypesAccess: 'seo/forms/typesAccess/fetch'
    })
  }
}
</script>
